<template>
  <div v-if="loaded" id="app">
    <join-form :options="options" />
    <copyright />
  </div>
</template>

<style lang="scss">
  @import "../assets/styles.scss";
  #chatbase-bubble-button {
    display: none;
  }
</style>
<script>
  import Copyright from '../components/Copyright'
  import joinForm from "../views/joinForm";
  export default {
    name: 'MembershipApp',
    components: {
      joinForm,
      Copyright
    },
    data() {
      return {
        loaded: false,
        options: false,
      }
    },
    mounted() {
      let url = '?method=options'
      if (window.metadata.year) {
        url += `&year=${window.metadata.year}`;
      }

      window.api.get(url).then(response => {
        this.options = response.data;
     
        this.loaded = true;
        console.log('options for join form:', this.options);
      });
    }
  }
</script>